import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { blogPosts } from '../data/mock';
import { Calendar, Clock, ArrowRight } from 'lucide-react';

export const JournalPage = () => {
  return (
    <div>
      <Navigation />

      {/* Hero Section */}
      <section style={{
        background: 'var(--bg-secondary)',
        padding: '120px 0 80px',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Indonesia Journal
          </h1>
          <p className="body-large" style={{ 
            color: 'var(--text-secondary)', 
            maxWidth: '700px', 
            margin: '0 auto' 
          }}>
            Stories, insights, and discoveries from across the Indonesian archipelago.
          </p>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '40px'
          }}>
            {blogPosts.map((post) => (
              <Link
                key={post.id}
                to={`/journal/${post.id}`}
                style={{
                  textDecoration: 'none',
                  display: 'block',
                  transition: 'transform 0.2s ease'
                }}
                className="hover-lift"
              >
                <div style={{
                  height: '300px',
                  overflow: 'hidden',
                  marginBottom: '24px',
                  borderRadius: 0
                }}>
                  <img
                    src={post.image}
                    alt={post.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                  />
                </div>
                
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  marginBottom: '12px'
                }}>
                  <span className="body-small" style={{
                    color: 'var(--text-primary)',
                    padding: '4px 12px',
                    background: 'var(--bg-secondary)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>
                    {post.category}
                  </span>
                  <span className="body-small" style={{
                    color: 'var(--text-secondary)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}>
                    <Calendar size={14} />
                    {post.date}
                  </span>
                  <span className="body-small" style={{
                    color: 'var(--text-secondary)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px'
                  }}>
                    <Clock size={14} />
                    {post.readTime}
                  </span>
                </div>

                <h2 className="heading-2" style={{ marginBottom: '12px' }}>
                  {post.title}
                </h2>

                <p className="body-regular" style={{ 
                  color: 'var(--text-secondary)', 
                  marginBottom: '16px',
                  lineHeight: 1.6
                }}>
                  {post.excerpt}
                </p>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  color: 'var(--interactive-base)',
                  fontSize: '14px'
                }}>
                  Read article
                  <ArrowRight size={16} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
